<template>
  <div style="height: 100%">
    <div v-if="false" style="height: 36px">
      <Dropdown>
        <Button type="text">画面展示</Button>
        <DropdownMenu slot="list">
          <DropdownItem v-for="(item, index) in pages" :key="index">
            <p @click="mySetPlayerNum(item)" style="padding: 6px 0">
              画面×{{ item }}
            </p>
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <Button type="text" @click="Close(-1)">关闭所有</Button>
      <Button type="text" @click="FullScreen">全屏观看</Button>
    </div>
    <iframe
      name="videoFrame"
      style="width: 100%; height: 100%"
      src="static/videoApi/livezz.html"
      frameborder="0"
    ></iframe>
  </div>
</template>
<script>
export default {
  data() {
    return { pages: [1, 2, 4, 6, 8, 9, 10, 13, 16] };
  },
  methods: {
    mySetPlayerNum(v) {
      window["videoFrame"].window.Screens(v);
    },
    FullScreen() {
      window["videoFrame"].window.FullScreen();
    },
    Close(t) {
      window["videoFrame"].window.Close(t);
      this.$emit("closeVideo");
    },
    open(v) {
      this.play(v);
    },
    play1(v) {
      var vvv = window["videoFrame"].window.getwinnum();

      if (vvv >= 10) {
        this.$Message.error("画面超过10个");
        return;
      }

      if (v.play) {
        console.log("视频数据", v);
        //this.$refs.vueVideo.open(obj);
        for (let i = 1; i <= 4; i++) {
          window["videoFrame"].window.play(v, i);
        }
      } else {
        //this.$refs.vueVideo.pause(obj);
        for (let i = 1; i <= 4; i++) {
          //window["videoFrame"].window.play(v, i);
          window["videoFrame"].window.pause(v, i);
        }
      }
    },
    play(v) {
      console.log("视频数据", v);
      window["videoFrame"].window.lyPlay(v);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/zhongzz/zhzz/video.vue